import Block from './Block';
import gsap from 'gsap'

export default class Tab extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()
    this.init()
  }

  getElems() {
    super.getElems()
    this.$titles = this.el.querySelectorAll('.b-tab__item-button')
    this.$rows = this.el.querySelectorAll('.b-tab__items-content .row')
    this.$rowsWrapper = this.el.querySelector('.b-tab__items-content')
    this.itemArray = []
    this.currentIndex = 0

    for (let i = 0; i < this.$titles.length; i++) {
      this.itemArray.push({
        title: this.$titles[i],
        row: this.$rows[i]
      })
    }
  }

  init() {
    this.rowWidth = this.$rowsWrapper.offsetWidth
  }

  resize() {
    this.rowWidth = this.$rowsWrapper.offsetWidth
    gsap.set(this.$rowsWrapper, { x: this.rowWidth * -this.currentIndex})
  }

  bindMethods() {
    this.tl = this.tl.bind(this)
  }

  tl(old, current, newIndex) {
    const tl = gsap.timeline({
      paused: true
    })

    /* eslint-disable prefer-reflect */
    tl.call(() => {
      old.title.classList.remove('active')
      current.title.classList.add('active')
    }, 0)

    tl.to(old.row, {
      opacity: 0
    })
    tl.addLabel('in')
    tl.set(this.$rowsWrapper, {
      x: this.rowWidth * -newIndex
    }, 'in')
    tl.fromTo(current.row, {
      opacity: 0
    }, {
      opacity: 1
    }, 'in')
    tl.set(this, {
      currentIndex: newIndex
    }, 'in')
    tl.play()
  }

  events() {
    super.events()
    for (let i = 0; i < this.itemArray.length; i++) {
      const element = this.itemArray[i];

      element.title.addEventListener('click', () => {
        if (this.currentIndex !== i) this.tl(this.itemArray[this.currentIndex], element, i)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Tab.js